import * as types from '../constants/recipe-cart';
import api from '../api';
import _get from 'lodash/get';
import { calcDistance } from '../utils/map';
import qs from 'query-string';
import localStorage from 'store';
import _find from 'lodash/find';
import toast from '../utils/toast';
import _pickBy from 'lodash/pickBy';
import i18n from 'i18next';
import hydrateVErrors from '../utils/vErrors';

export const setLocation = payload => dispatch => {
  dispatch({
    type: types.SET_LOCATION,
    payload,
  });

  dispatch(setMapCenter(payload));
};

export const setMapCenter = payload => async dispatch => {
  dispatch({
    type: types.SET_MAP_CENTER,
    payload,
  });
};

const updateServerCart = goodsId => (dispatch, getState) => {
  try {
    let uid = getState().user.uuid;
    let cartItems = getState().recipeCart.items;
    let item = _find(cartItems, { id: goodsId }) || { in_cart: 0 };
    let form = {
      uid,
      goods_id: goodsId,
      quantity: item.in_cart,
    };
    api.post('/cart', form);
  } catch (e) {
    console.error(e);
  }
};

export const addToCart = item => dispatch => {
  let cartItems = [];
  cartItems.push({
    ...item,
    in_cart: 1,
  });

  dispatch({
    type: types.ADD_TO_CART,
    payload: cartItems,
  });
  localStorage.set('recipe_cart_items', cartItems);
  return true;
};

export const removeFromCart = (item, remove = false) => (
  dispatch,
  getState
) => {
  //todo logging activity about removing from cart
  //todo this place for removing items from card
  //this also can work as -- from shopping cart page
  //we can to this via filtering data
  let cartItems = getState().recipeCart.items;
  let itemInCart = _find(cartItems, { id: item.id });
  //fixme better to throw exception
  if (!itemInCart) return;

  if (itemInCart.in_cart > 1 && !remove) {
    cartItems = cartItems.map(i => {
      if (i.id === item.id) {
        i.in_cart--;
      }

      return i;
    });
  } else {
    cartItems = cartItems.filter(i => i.id !== item.id);
  }

  dispatch({
    type: types.ADD_TO_CART,
    payload: cartItems,
  });
  dispatch(updateServerCart(item.id));
};

export const setItemCount = (id, value) => (dispatch, getState) => {
  let items = getState().recipeCart.items;

  if (value === 0) {
    items = items.filter(i => i.id !== id);
  } else {
    items = items.map(i => {
      if (i.id === id) {
        i.in_cart = value;
      }

      return i;
    });
  }

  dispatch({
    type: types.SET_CART_ITEM_COUNT,
    payload: items,
  });
  dispatch(updateServerCart(id));
};

export const selectOffer = offerId => (dispatch, getState) => {
  try {
    if (offerId) {
      let offers = getState().recipeCart.pharmacyOffers;
      let cartItems = getState().recipeCart.items;
      let found = _find(offers, { id: offerId });

      found = {
        ...found,
        order: {
          ...found.order,
          goods: found.order.goods.map(i => {
            let fromCart = _find(cartItems, { id: i.goods_id });

            return {
              ...i,
              in_cart: fromCart.in_cart,
              goods_name: fromCart.goods_name,
              release_form: fromCart.release_form,
              name: fromCart.name,
              goods_producer: fromCart.goods_producer,
              _id: fromCart._id,
            };
          }),
        },
      };

      dispatch({ type: types.SELECT_OFFER, payload: found });
    } else {
      dispatch({ type: types.SELECT_OFFER, payload: null });
    }
  } catch (e) {
    console.error(e);
    toast.error({
      message: e.message,
    });
  }
};

export const getEHealthRecipe = payload => async (dispatch, getState) => {
  try {
    let recipe = payload ? payload : localStorage.get('recipe');
    let location = getState().recipeCart.location;
    dispatch({ type: types.GET_EHEALTH_RECIPE_START });
    let { data } = await api.get(`/ehealth/${recipe}`, {
      params: {
        latitude: location.latitude,
        longitude: location.longitude,
        radius: 20000,
      },
    });
    dispatch({ type: types.GET_EHEALTH_RECIPE_SUCCESS, payload: data });
    return data;
  } catch (e) {
    dispatch({ type: types.GET_EHEALTH_RECIPE_FAILURE, payload: e });
  }
};

export const loadingOffersMethod = async getState => {
  let mapCenter = getState().recipeCart.mapCenter;
  let userLocation = getState().recipeCart.location;

  let items = getState().recipeCart.items.map(i => parseInt(i.id));
  let recipeNumber =
    getState().recipeCart.data.recipe_number || localStorage.get('recipe');

  let params = {
    goods_id: items,
    latitude: mapCenter ? mapCenter.latitude : null,
    longitude: mapCenter ? mapCenter.longitude : null,
  };

  let queryString = qs.stringify(params);
  let { data } = await api.get(`/ehealth/${recipeNumber}/drugstores`, {
    params,
    paramsSerializer: () => queryString,
  });

  // eslint-disable-next-line array-callback-return
  return data.map(i => {
    let order = i.order;

    if (order) {
      let onlinePrice = _get(order, 'online_total', null);
      let drugstorePrice = _get(order, 'drugstore_total', null);

      return {
        ...i,
        order: {
          ...order,
          goods: _get(order, 'goods', []),
          online_total: onlinePrice ? onlinePrice.toFixed(2) : null,
          drugstore_total: drugstorePrice ? drugstorePrice.toFixed(2) : null,
        },
        distance: onlinePrice
          ? calcDistance(userLocation, i.coordinates)
          : null,
      };
    }
  });
};

export const fetchEHealthDrugstores = () => async (dispatch, getState) => {
  try {
    if (!getState().recipeCart.items.length) {
      dispatch({ type: types.GET_EHEALTH_DRUGSTORES_SUCCESS, payload: [] });

      return;
    }
    dispatch({ type: types.GET_EHEALTH_DRUGSTORES_START });
    let data = await loadingOffersMethod(getState);
    data = data.filter(item => item);
    if (data.length)
      dispatch({ type: types.GET_EHEALTH_DRUGSTORES_SUCCESS, payload: data });
  } catch (e) {
    dispatch({ type: types.GET_EHEALTH_DRUGSTORES_FAILURE, payload: e });
  }
};

const setLoader = payload => ({
  type: types.SET_LOADER,
  payload,
});

export const setVErrors = payload => ({
  type: types.SET_V_ERRORS,
  payload,
});

export const storeOrderFailure = payload => dispatch => {
  dispatch({
    type: types.STORE_ORDER_FAILURE,
    payload,
  });
};

export const flushRecipeCart = () => dispatch => {
  dispatch({ type: types.FLUSH_ALL });
  localStorage.remove('recipe_cart_items');
};

export const eHealthStore = payload => async (dispatch, getState) => {
  try {
    let recipeCartState = getState().recipeCart;
    let recipeNumber = localStorage.get('recipe');
    let offer = recipeCartState.selectedOffer;
    let drugstore_id = offer.id;
    let goods_id = offer.order.goods[0].goods_id;
    let total = offer.order.total;

    let form = _pickBy(
      {
        customer: {
          ...payload.customer,
        },
        goods_id,
        total,
        drugstore_id,
        _recaptcha: payload._recaptcha,
      },
      v => v !== null && v !== undefined && v !== ''
    );

    dispatch(setLoader(true));
    const {
      data: { data },
    } = await api.post(`/ehealth/${recipeNumber}/store`, form);
    dispatch({ type: types.STORE_ORDER_SUCCESS, payload: data });
    toast.success({
      message: i18n.t('messages.info.thank_you_for_order'),
      placement: 'bottomright',
    });
    dispatch(flushRecipeCart());
    localStorage.remove('recipe');
    dispatch(setLoader(false));

    return true;
  } catch (e) {
    console.error(e);
    dispatch(storeOrderFailure());
    dispatch(setVErrors(hydrateVErrors(e)));
    dispatch(setLoader(false));
  }
};

export const flushConfirm = () => dispatch => {
  dispatch({ type: types.FLUSH_CONFIRM });
};
